export default "__VITE_PUBLIC_ASSET__87170475__"